import WorkoutsBackButton from './WorkoutsBackButton';

export default WorkoutsBackButton;
